var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"controlled-guide-container"},[_vm._t("reference"),(_vm.showGuide)?_c('div',{staticClass:"guide-container",class:[("beacon-" + _vm.position)]},[_vm._t("guide")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }